import React, { Component } from "react";
import { connect } from "react-redux";
//import axios from 'axios';
//import { withRouter } from 'react-router-dom';

import { createEquipment } from '../../../actions/equipmentActions';

class EquipmentCreate extends Component {

    constructor() {
        super();
        this.state = {
            activePhoto: true,
            activeVideo: true,
            file: null,
            checkInputErrorMessage: false,
            sendingDataErrorMessage: false
        }
    }

    // Срабатывает при переключения значка фото
    switchPhoto() {
        this.setState({
            activePhoto: !this.state.activePhoto
        });

    }

    // Срабатывает при переключения значка видео
    switchVideo() {
        this.setState({
            activeVideo: !this.state.activeVideo
        });
    }

    createEquipment() {
        // Если ошибка выводит сообщение
        if (this.state.activePhoto === false && this.state.activeVideo === false) {
            this.setState({
                checkInputErrorMessage: true
            });
        } else {
            this.setState({
                checkInputErrorMessage: false
            });
        }
    }

    // Срабатывает когда фото в form
    handleImageChange(e) {
        e.preventDefault();

        const reader = new FileReader();
        const file = e.target.files[0];

        this.setState({ file: file });

        reader.onloadend = () => {
            const res = reader.result
            this.refs.image.src = res
        }

        reader.readAsDataURL(file)
    }

    //  Возращает тип камеры
    getCamType() {
        if (this.state.activePhoto === true && this.state.activeVideo === false) {
            return 0;
        } else if (this.state.activePhoto === false && this.state.activeVideo === true) {
            return 1;
        } else if (this.state.activePhoto === true && this.state.activeVideo === true) {
            return 2;
        }
    }

    // Перенаправляет на список оборудования
    backEquipmentToPage() {
        const { session, history } = this.props;
        history.push(`/profile/${session.currentUser.id}/equipment`);
    }

    // При нажатие создает новое оборудование
    handleSubmitCreate(event) {
        event.preventDefault();

        if (this.state.checkInputErrorMessage === false) {
            const formData = new FormData();

            formData.append(`title`, this.refs.title.value);
            formData.append(`width`, this.refs.width.value);
            formData.append(`height`, this.refs.height.value);
            formData.append(`cam_type`, this.getCamType());
            formData.append(`image`, this.state.file);
            formData.append(`imei`, '')

            const { dispatch } = this.props;

            dispatch(createEquipment(formData, () => this.backEquipmentToPage()));
        }
    }

    render() {
        const isFetching = this.props.equipments.isFetching
        return (
            <div className="menu-content-equipment-edit menu-content-item tab-parent screen-bottom-block">
                <div className="rounded-white-block">


                    <div className="white-block-top">
                        <h3>Создать оборудование</h3>
                    </div>

                    <div className="white-block-content">

                        <div className="edit-form-wrap">

                            <form id="formCreate" action="" onSubmit={(event) => { this.handleSubmitCreate(event) }}>
                                <input type="text" placeholder="Модель телефона" required className="width100" ref="title" />

                                <input type="text" placeholder="Ширина снимка (px)" required pattern="^[0-9]+$" className="width100" ref="width" />

                                <input type="text" placeholder="Высота снимка (px)" required pattern="^[0-9]+$" className="width100" ref="height" />

                                <div className="icon-wrap" >
                                    <div className="actions-text">
                                        <div className="icon-text-photo">Фото</div>
                                        <div className="icon-text-video">Видео</div>
                                    </div>
                                    <div className="actions" >
                                        <div className={this.state.activePhoto ? "action-photo" : "action-photo not-exist"}
                                            onClick={() => { this.switchPhoto() }}>
                                        </div>
                                        <div className={this.state.activeVideo ? "action-video" : "action-video not-exist"}
                                            onClick={() => { this.switchVideo() }}>
                                        </div>
                                    </div>
                                </div>
                                {
                                    this.state.checkInputErrorMessage
                                        ? <span className="input-error-text">Нужно выбрать фото или видео.</span> : ''
                                }

                                <input style={{marginBottom:'10px'}} type="file" name="imageFile" accept="image/jpeg,image/png" required onChange={this.handleImageChange.bind(this)} ref="imageFile" />
                                <div style={{fontSize:'13px'}}>Приложите тестовый снимок (в максимальном качестве)</div>
                                <img style={{marginTop:'20px',marginBottom:'0'}} ref="image" alt="" />
                            </form>

                            {
                                this.state.sendingDataErrorMessage
                                    ? <span className="input-error-text">Ошибка отправки данных</span> : ''
                            }
                        </div>


                        <div className="actions-button-equipment">
                            <button className="equipment-btn equipment-btn-empty" onClick={() => { this.backEquipmentToPage() }}>Отмена</button>
                            <button 
                                className={"equipment-btn equipment-btn-full" + (isFetching ? " disabled" : "")} 
                                form="formCreate" 
                                onClick={() => { this.createEquipment() }}
                            >
                                Создать
                            </button>
                        </div>

                    </div>


                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(EquipmentCreate);


// WEBPACK FOOTER //
// ./src/components/Profile/SubEquipment/EquipmentCreate.js